// This is the prod url for the Azure Logic App that handles MU form processing.

var url;

// submitConfig must be included if you want to redirect to a thank you page. If you don't want to, don't provide it. If you do include submitConfig, it must be an object consisting of redirectToThankYou: true, thankYouType (some value that the thank you page understands) and thankYouForm (some value that the thank you page understands).
export async function handleSubmit(formValues, submitConfig) {
  if (
    submitConfig.thankYouType === "ois" ||
    submitConfig.onlineApplication === "true"
  ) {
    url =
      "https://prod-10.westcentralus.logic.azure.com:443/workflows/0fe22f429bc74a5cb8ab242ea562dd81/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yMhNbEyBhp2yG2hQvI10opZi4C3UAvdxOIO7LJIpAhE";
  } else {
    url =
      "https://prod-09.westcentralus.logic.azure.com:443/workflows/8c39d89aef1d4ebab7a131cc286d7d99/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=BtHVmT4_d9IiEqMd50m2sO7N0mwxWz7pW2Q_t5hH_wQ";
  }
  const submitResponse = await fetch(url, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
    method: "post",
    body: JSON.stringify(formValues),
  });
  const responseData = await submitResponse.json();
  if (submitConfig.preferThankYou == true) {
    redirectToThankYou(formValues, submitConfig);
  }
}
function redirectToThankYou(formValues, submitConfig) {
  if (
    (submitConfig.displayText != null) | undefined &&
    (submitConfig.backButtonAction != null) | undefined
  ) {
    window.location.href = `/thankyou/?type=${submitConfig.thankYouType}&form=${submitConfig.thankYouForm}&firstName=${formValues.submitFirstName}&displayText=${submitConfig.displayText}&backButtonAction=${submitConfig.backButtonAction}`;
  } else if (submitConfig.onlineApplication === "true") {
    window.location.href = `/admissions/graduate-admissions/apply-online/online-application`;
  } else if (submitConfig.impactScholarship === "true") {
    window.location.href = `/admissions/tuition-and-financial-aid/impact-scholarships/apply`;
  } else {
    window.location.href = `/thankyou/?type=${submitConfig.thankYouType}&form=${submitConfig.thankYouForm}&firstName=${formValues.submitFirstName}`;
  }
}
